
import Loader from "react-loader-spinner";
import { useForm } from "react-hook-form";
import { faCommentAlt } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState, useRef, Fragment } from "react";
import { Button, Card, Form, FormGroup } from "react-bootstrap";
import { CheckLg, DashCircle, Link45deg, PlusSquareFill, X } from "react-bootstrap-icons";
import { useDispatch } from "react-redux";
import { addCustomerTicket, getCustomerTicketList, getCustomerTicket, getCustomerTicketList_Local } from "../store/api/CustomerApi";
import { attachFile, downloadFile } from "../store/api/Services";
import BihamtaTable from "../Components/BihamtaTable";

const Ticket = () => {
    const frmTicket = useRef();
    const inputFile = useRef();
    const filterData = useRef({});
    const dispatch = useDispatch();
    const [currTicket, setCurrTicket] = useState(null);
    const { register, errors, handleSubmit } = useForm();
    const tableColes = [
        { colTitle: "ردیف", colName: "RowNumber", justInMobile: true, styleCondition: (row) => row.IsNew ? { fontWeight: "bold" } : { fontWeight: "normal" } },
        { colTitle: " وضعیت تیکت", colName: "PTicketStatus", justInMobile: true, styleCondition: (row) => row.IsNew ? { fontWeight: "bold" } : { fontWeight: "normal" } },
        { colTitle: "تاریخ تیکت", colName: "PTicketDate", justInMobile: true, styleCondition: (row) => row.IsNew ? { fontWeight: "bold" } : { fontWeight: "normal" } },
        { colTitle: "موضوع تیکت", colName: "TicketSubject", justInMobile: true, styleCondition: (row) => row.IsNew ? { fontWeight: "bold" } : { fontWeight: "normal" } },
        { colTitle: "شرح تیکت", colName: "TicketDesc", justInMobile: false, colType: "string", maxTextLength: 150, styleCondition: (row) => row.IsNew ? { fontWeight: "bold" } : { fontWeight: "normal" } },
        { colTitle: "شناسه پیگیری", colName: "ID", justInMobile: false, styleCondition: (row) => row.IsNew ? { fontWeight: "bold" } : { fontWeight: "normal" } }
    ]
    const tableRowButtons = [{
        title: "نمایش جزئیات", type: "show", className: "group-Btn-smalll btn-primary",
        onclick: (item) => showTicket(item)
    }];
    function addTicket(data) {
        const onSuccess = (res) => {
            const id = res.ResponseID ? res.ResponseID : res.ID;
            attachFile(inputFile.current, id, "CustomerTicket", () => frmTicket.current.reset())
            //For When Ticket Is New
            if (res.ID && res.TotalCount) {
                dispatch(getCustomerTicketList_Local({ ...res }));
                setCurrTicket({ ID: res.ID, ...data });
            }
            //
            else if (res.Data) {
                setCurrTicket({ ...res.Data });
            }
        }
        dispatch(addCustomerTicket(data, onSuccess));
    }
    function prepareforAdd() {
        setCurrTicket({
            ParentID: null,
            ID: 0,
            TicketSubject: "",
            TicketDesc: ""
        })
    }
    function cancelTicket() {
        setCurrTicket(null);
    }
    function showTicket(ticket) {
        setCurrTicket("PENDING");
        const onGet = (res) => {
            setCurrTicket(res?.Data);
        }
        dispatch(getCustomerTicket(ticket.ID, onGet));
    }
    useEffect(() => {
        document.body.classList = "notMain";
        dispatch(getCustomerTicketList({ ByCustomer: true }));
    }, []);
    return (
        <div className="container-fluid mt-2">
            <br />
            <Card style={{ textAlign: "right" }}>
                <Card.Header className="headerStyle">
                    <FontAwesomeIcon icon={faCommentAlt} size="lg" />
                    &nbsp;
                    <h6 style={{ display: "inline-block", margin: "auto" }}>تیکت های من</h6>
                </Card.Header>
                <Card.Body className="bodyStyle">
                    {currTicket &&
                        <div className="rowBorder" style={{ padding: "10px" }}>
                            {
                                currTicket === "PENDING" && <div style={{ textAlign: "center" }}> <Loader type="BallTriangle" width={25} height={25} color="#bb1370" /></div>
                            }
                            {Number(currTicket.ID) > 0 &&

                                <div style={{ position: "relative" }}>
                                    {currTicket.TicketStatus === "Closed" && <label style={{ padding: "5px", color: "red", border: "2px solid red", borderRadius: "2px", transform: "rotate(-20deg)", boxShadow: "0 0 3px", textShadow: "0px 0px 2px red", position: "absolute", left: "-25px", top: "-20px" }}>بسته شده</label>}
                                    <div>
                                        <label style={{ background: "#941262", padding: "5px", color: "white", borderRadius: "2px", marginLeft: "3px" }}>تاریخ ثبت: {currTicket.PTicketDate}</label>
                                        <label style={{ background: "#3560b1", padding: "5px", color: "white", borderRadius: "2px" }}>شناسه پیگیری: {currTicket.ID}</label>
                                        {Number(currTicket.AttachmentID) > 0 && <Link45deg size={25} color="#c32baa" className="hoverIcon" onClick={() => downloadFile(currTicket.AttachmentID, "CustomerTicket")} />}
                                    </div>
                                    <div className="mt-2">
                                        <label>موضوع: </label>
                                        <Form.Control value={currTicket.TicketSubject} disabled={true} style={{ fontSize: "13px", fontWeight: "bold" }} />
                                    </div>
                                    <div className="mt-2">
                                        <label>شــرح: </label>
                                        <Form.Control as="textarea" rows={2} value={currTicket.TicketDesc} disabled={true} style={{ fontSize: "13px" }} />
                                    </div>
                                </div>

                            }
                            {!(Number(currTicket.ID) > 0 ) && currTicket !=="PENDING" &&
                                <form ref={frmTicket} onSubmit={handleSubmit(addTicket)} readOnly>
                                    <FormGroup>
                                        <label>موضوع: </label>
                                        <Form.Control name="TicketSubject" ref={register({ required: true })} />
                                        {errors.TicketSubject && <small className="erros">موضوع تیکت الزامی است</small>}
                                    </FormGroup>
                                    <FormGroup>
                                        <label>شــرح: </label>
                                        <Form.Control as="textarea" rows={3} name="TicketDesc" ref={register({ required: true })} />
                                        {errors?.TicketDesc && <small className="errors">شرح تیکت الزامی است</small>}
                                    </FormGroup>
                                    <Fragment>
                                        <Form.Group>
                                            <label>پیوست: </label>
                                            <input type="file" className="form-control" ref={inputFile} />
                                        </Form.Group>
                                        <div className="mt-2">
                                            <Button className="group-Btn" variant="success" type="submit"><CheckLg size={15} />&nbsp;ثبت تیکت</Button>
                                            <Button className="group-Btn" variant="danger" size="15" onClick={cancelTicket}><DashCircle />&nbsp;انصراف</Button>
                                        </div>
                                    </Fragment>
                                </form>
                            }
                            {
                                currTicket.Responses && Array.isArray(currTicket.Responses) && currTicket.Responses.length > 0 &&
                                <div className="rowBorder mt-4" style={{ borderColor: "#ff00003b" }}>
                                    <div className="rowTitle">پاسخ ها</div>
                                    <div style={{ maxHeight: "395px", overflow: "auto" }}>
                                        {currTicket.Responses.map((res, i) =>
                                            <Card style={{ margin: "12px", background: "transparent" }} key={i}>
                                                <Card.Body>
                                                    <div style={{ position: "absolute", padding: "5px", background: "#c470e5", top: "-5px", left: "-5px", transform: "rotate(-20deg)", fontSize: "11px", borderRadius: "2px", boxShadow: "0px 0px 2px" }}>
                                                        {res.PTicketDate}
                                                    </div>
                                                    <div style={{ position: "absolute", padding: "1px 5px 1px 5px", background: "#7077e5", top: "16px", left: "6px", transform: "rotate(-10deg)", fontSize: "11px", borderRadius: "2px", color: "white", boxShadow: "0px 0px 2px black" }}>
                                                        {res.TicketHour}
                                                    </div>
                                                    {res.AttachmentID &&
                                                        <div style={{ position: "absolute", padding: "1px 5px 1px 5px", top: "5px", left: "50px", color: "#ff2300" }} className="hoverIcon">
                                                            <Link45deg size={24} onClick={() => downloadFile(res.AttachmentID, "CustomerTicket")} />
                                                        </div>
                                                    }
                                                    {i === 0 &&
                                                        <span className="form-control" style={{ backgroundColor: res.ResponderName ? "#ede9ef" : "#dadef6", border: "none", fontSize: "13px", minHeight: "50px" }}>{res.TicketDesc}</span>
                                                    }
                                                    {i > 0 &&
                                                        <Form.Control as="textarea" rows={window.innerWidth > 414 ? 2 : 3} value={res.TicketDesc} readOnly style={{ backgroundColor: res.ResponderName ? "#ede9ef" : "#dadef6", border: "none", fontSize: "13px" }} />}
                                                    <div style={{ position: "absolute", padding: "1px 5px 1px 5px", background: "#595a95", bottom: "22px", left: "22px", fontSize: "11px", borderRadius: "2px", color: "white", boxShadow: "0px 0px 2px black" }}>
                                                        {res.ResponderName ? res.ResponderName : "خودم"}
                                                    </div>
                                                </Card.Body>
                                            </Card>
                                        )
                                        }
                                    </div>
                                </div>
                            }
                            {Number(currTicket.ID) > 0 && currTicket.TicketStatus !== "Closed" &&
                                <form ref={frmTicket} onSubmit={handleSubmit(addTicket)} readOnly>
                                    <input type="hidden" name="ParentID" ref={register({ required: true })} value={currTicket.ID} />
                                    <FormGroup>
                                        <label>شــرح: </label>
                                        <Form.Control as="textarea" rows={2} name="TicketDesc" ref={register({ required: true })} />
                                        {errors?.TicketDesc && <small className="errors">شرح تیکت الزامی است</small>}
                                    </FormGroup>
                                    <Fragment>
                                        <Form.Group>
                                            <label>پیوست: </label>
                                            <input type="file" className="form-control" ref={inputFile} />
                                        </Form.Group>
                                        <div className="mt-2">
                                            <Button className="group-Btn" variant="info" type="submit"><CheckLg size={15} />&nbsp;ثبت پاسخ</Button>
                                            <Button className="group-Btn" variant="danger" onClick={cancelTicket}><DashCircle size={15} />&nbsp;انصراف</Button>
                                        </div>
                                    </Fragment>
                                </form>
                            }
                            {currTicket.TicketStatus === "Closed" &&
                                <Button className="group-Btn mt-2" variant="danger" onClick={cancelTicket}><X size={20} />&nbsp;بستن</Button>
                            }
                        </div>

                    }
                    {!currTicket && <PlusSquareFill color="#3131c8" size={30} onClick={prepareforAdd} style={{ cursor: "pointer", borderRadius: "4px", boxShadow: "0 0 4px black" }} />}
                    <BihamtaTable columns={tableColes} rowButtons={tableRowButtons} filterData={filterData.current} searchMethod={(data) => dispatch(getCustomerTicketList(data))} reducerName="customerDataReducer" objectName="customerTicketList" />
                </Card.Body>
            </Card>
        </div>
    )
}
export default Ticket;